import React, { useEffect } from 'react';
import StatementCard from 'components/statement_card/statement_card.component';
import Footer from 'components/footer/footer.component';
import Header from 'components/header/header.component';
import Button from 'components/button/button.component';
import 'screens/user_screens/notification_schemes.screen.scss';
import Navbar from 'components/navbar/navbar.component';
import { getAllDetails } from 'models/public.model';
import moment from 'moment';
import Pagination from 'react-js-pagination';
import { GET_STATEMENTS } from 'utils/types.utils';
import { throwError, useSetState } from 'utils/common.utils';
import { useDispatch, useSelector } from 'react-redux';

export default function Schemes(props) {
  const dispatch = useDispatch();
  const statements = useSelector(
    (state: any) => state.announcements.statements,
  );
  const [state, setState] = useSetState({
    search: '',
    loading: true,
    page: 1,
    limit: 4,
    title: '',
    description: '',
    url: '',
  });
  const handlePageChange = (pageNumber) => {
    setState({ activePage: pageNumber, page: pageNumber });
  };
  const handleGetAllDetails = async () => {
    try {
      const data = {
        page: state.page,
        search: '',
        type: 'govt',
        limit: state.limit,
      };
      const res: any = await getAllDetails(data);
      const details = res.data.docs.map((document) => {
        document.fileName = document.pdf[0].split('/').pop();
        document.date = moment(document.date).format('DD-MM-YYYY');
        return document;
      });
      res.data.docs = details;
      dispatch({
        type: GET_STATEMENTS,
        payload: res.data,
      });
    } catch (err:any) {
      throwError(err.data ? err.data.desc : 'Failed to get Details');
    }
  };

  useEffect(() => {
    handleGetAllDetails();
  }, [state.page]);
  return (
    <div className="schemes_screen">
      <div className="schemes_container">
        <div className="schemes_wrapper">
          <div className="schemes_header_wrapper">
            <Header />
          </div>
          <div className="schemes_navbar_wrapper">
            <Navbar {...props} />
          </div>
          <div className="schemes_title_wrapper">
            <div className="schemes_title h2">
              Government Notification Schemes
            </div>
            <div className="schemes_line_wrapper"> </div>
          </div>
          <div className="schemes_content_wrapper">
            <div className="schemes_content">
              {statements && statements.docs.map((statement) => {
                  return (
                    <div className="schemes_content_event_card">
                      <StatementCard
                        title={statement.title}
                        date={statement.date}
                        heading="Free Coaching and Allied Scheme for The
                                  Candidates/Students Belonging to Minority Communities"
                        description={statement.description.length > 150 ? `${statement.description.substring(0, 235)}` : statement.description}
                        pdfName={statement.pdf}
                      />
                    </div>
                  );
                })}
            </div>
            <div className="pagination_wrapper">
              <div className="pagination">
                <Pagination
                  activePage={state.activePage}
                  activeLinkClass="link_active"
                  itemsCountPerPage={state.limit}
                  totalItemsCount={
                    statements && statements.totalDocs
                      ? statements.totalDocs
                      : 10
                  }
                  pageRangeDisplayed={6}
                  firstPageText="<<"
                  lastPageText=">>"
                  prevPageText="<"
                  nextPageText=">"
                  itemClassFirst="firstElement"
                  onChange={(e) => handlePageChange(e)}
                />
              </div>
            </div>
          </div>
          <div className="schemes_footer_wrapper">
            <div className="schemes_footer">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
